module.exports = __webpack_public_path__ + "img/selected1-min.26233e88.png";